import constants from "constants";
import centralApiInstance from "./axiosInstances/central";
import marketingApiInstance from "./axiosInstances/marketing";
import authServiceInstance from "./axiosInstances/auth";

export const loginUser = ({ email, password }) =>
  authServiceInstance.post(`apis/auth/v5/login`, {
    username: email,
    password,
  });
// Staff sign-in with Google. The browser is sent to iamauth, which sends it
// back to the login page with a one-time code that is swapped here for the
// same response password login gives.
export const getSsoStartUrl = (challenge, provider = "google") =>
  `${constants.authServiceUrl}/apis/auth/v5/sso/${provider}/start?app=phoenix&code_challenge=${challenge}`;
export const exchangeSsoCode = (code, codeVerifier) =>
  authServiceInstance.post(`apis/auth/v5/sso/exchange`, { code, codeVerifier });
export const logoutUser = () => authServiceInstance.post(`apis/logout`);
export const authenticate = () =>
  centralApiInstance.get(`apis/v2/authenticate/`);
export const getAllPossibleRoles = () =>
  authServiceInstance.get(`apis/v2/roles?size=100`);
export const getAllPossibleRoleGroups = () =>
  authServiceInstance.get(`apis/v2/role-groups?size=100`);

export const userAccessibleFeatures = () =>
  marketingApiInstance.get(`/features/permitted`);

export const getAccountByEmail = (params) =>
  authServiceInstance.get(`apis/auth/v4/accounts/by-email`, { params });

export const getUsersByPhone = ({
  countryCode,
  phoneNumber,
  page = 0,
  size = 0,
}) =>
  authServiceInstance.get(`apis/auth/v6/user-identity/users`, {
    params: { page, size, phoneNumber, countryCode },
  });
